var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import dayjs from 'dayjs';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import * as React from 'react';
import { getDatePickerLocaleText } from '../../../application/common/constants/get-date-picker-locale-text';
import useTranslate from '../../../localization/helpers';
dayjs.extend(isBetweenPlugin);
var CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: function (prop) {
        return prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay';
    }
})(function (_a) {
    var theme = _a.theme, dayIsBetween = _a.dayIsBetween, isFirstDay = _a.isFirstDay, isLastDay = _a.isLastDay;
    return (__assign({ borderRadius: '50%', '&:hover': {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.dark
        } }, ((isFirstDay || isLastDay) && {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main
    })));
});
function Day(props) {
    var day = props.day, startDay = props.startDay, endDay = props.endDay, other = __rest(props, ["day", "startDay", "endDay"]);
    if (!startDay && !endDay) {
        return _jsx(PickersDay, __assign({ day: day }, other));
    }
    var start = startDay || endDay;
    var end = endDay || startDay;
    var dayIsBetween = day.isBetween(start, end, null, '[]');
    var isFirstDay = day.isSame(start, 'day');
    var isSunday = day.day() === 0;
    var isSaturday = day.day() === 6;
    var isLastDay = day.isSame(end, 'day');
    return (_jsx("div", { style: __assign(__assign(__assign({}, (dayIsBetween && {
            backgroundColor: '#eee'
        })), ((isFirstDay || isSunday) && {
            borderTopLeftRadius: '50%',
            borderBottomLeftRadius: '50%'
        })), ((isLastDay || isSaturday) && {
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%'
        })), children: _jsx(CustomPickersDay, __assign({}, other, { day: day, sx: dayIsBetween ? { px: 2.5, mx: 0 } : {}, dayIsBetween: dayIsBetween, isFirstDay: isFirstDay, isLastDay: isLastDay })) }));
}
function CustomTextField(props) {
    var error = props.error, startDay = props.startDay, endDay = props.endDay;
    return (_jsx(TextField, __assign({}, props, { size: 'small', fullWidth: true, error: !!error, helperText: error && "* ".concat(error), sx: { minWidth: '280px' }, placeholder: 'Start - End', value: "".concat(startDay ? startDay.format('D MMM YYYY') : 'Start', " - ").concat(endDay ? endDay.format('D MMM YYYY') : 'End') })));
}
export default function DateRangePicker(_a) {
    var value = _a.value, onChange = _a.onChange, maxDate = _a.maxDate, minDate = _a.minDate, error = _a.error, disabled = _a.disabled;
    var _b = __read(React.useState(true), 2), startTurn = _b[0], setStartTurn = _b[1];
    var _c = __read(React.useState(null), 2), pendingStartDate = _c[0], setPendingStartDate = _c[1];
    var startDay = value[0];
    var endDay = value[1];
    var translate = useTranslate().translate;
    React.useEffect(function () {
        if (startDay && endDay) {
            setStartTurn(true);
            setPendingStartDate(null);
        }
    }, [startDay, endDay]);
    var updateValue = function (newVal) {
        onChange(newVal);
    };
    var handleChange = function (newValue) {
        if (!newValue) {
            return;
        }
        if (pendingStartDate) {
            if (newValue.isBefore(pendingStartDate)) {
                updateValue([newValue, pendingStartDate]);
                setStartTurn(false);
                setPendingStartDate(null);
            }
            else {
                updateValue([pendingStartDate, newValue]);
                setStartTurn(true);
                setPendingStartDate(null);
            }
            return;
        }
        if (startDay && endDay && (newValue.isAfter(endDay) || newValue.isBefore(startDay))) {
            setPendingStartDate(newValue);
            updateValue([newValue, null]);
            setStartTurn(false);
            return;
        }
        var currentStartDay = pendingStartDate || startDay;
        if (startTurn) {
            updateValue([newValue, endDay]);
            setStartTurn(false);
        }
        else {
            if (currentStartDay) {
                if (newValue.isBefore(currentStartDay)) {
                    updateValue([newValue, currentStartDay]);
                    setStartTurn(false);
                    setPendingStartDate(null);
                }
                else {
                    updateValue([currentStartDay, newValue]);
                    setStartTurn(true);
                    setPendingStartDate(null);
                }
            }
        }
    };
    var currentStartDay = pendingStartDate || startDay;
    var currentEndDay = endDay;
    var calendarValue = startTurn ? currentStartDay : currentStartDay || endDay;
    return (_jsx(DatePicker, { localeText: getDatePickerLocaleText(), enableAccessibleFieldDOMStructure: false, value: calendarValue, label: translate('common.dateRange'), onChange: handleChange, showDaysOutsideCurrentMonth: true, disableHighlightToday: true, closeOnSelect: false, maxDate: maxDate, minDate: minDate, autoFocus: false, disabled: disabled, slots: { day: Day, textField: CustomTextField }, slotProps: {
            inputAdornment: {
                sx: {
                    '& .MuiButtonBase-root.MuiIconButton-root': {
                        width: 32,
                        height: 32
                    }
                },
                onMouseDown: function (event) {
                    event.preventDefault();
                }
            },
            day: {
                startDay: currentStartDay,
                endDay: currentEndDay
            },
            textField: {
                error: error,
                startDay: currentStartDay,
                endDay: currentEndDay
            }
        } }));
}
